// extracted by mini-css-extract-plugin
export default {"salesWelcomeCard":"style_salesWelcomeCard__nMWFN"};